export const invoicePaymentFormPaymentType = [
    {
        value: 1,
        label: "Tek Seferde Ödeme",
    },
    {
        value: 2,
        label: "Parçalı Ödeme",
    },
];

export const getInvoicePaymentFormPaymentTypeOptionById = (id: number) => {
    var index = invoicePaymentFormPaymentType.findIndex(w => w.value == id);
    return invoicePaymentFormPaymentType[index];
}